(() => {
  'use strict';
  if (window.mmNewsletterCaptureInitialized) return;
  window.mmNewsletterCaptureInitialized = true;

  const locks = new WeakMap();
  let opener = null;
  let overflow = null;
  const dialog = () => document.querySelector('[data-mm-newsletter-dialog]');
  const rendered = (element) => {
    if (!element || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    for (let current = element; current instanceof Element; current = current.parentElement) {
      const style = window.getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    return Array.from(element.getClientRects()).some(rect => rect.width > 0 && rect.height > 0);
  };
  const visible = element => rendered(element) && Array.from(element.getClientRects()).some(rect => rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth);
  const otherInterfaceOpen = (popup) => {
    const selectors = 'dialog[open], [role="dialog"][aria-modal="true"], details-modal[open], cart-drawer[open], cart-drawer.active, .drawer.active, .drawer--active, .modal[open], .modal.is-active, .r32-header details[open], .shopify-section-header-sticky details[open], [data-mm-cookie-consent], .mc-modal, .mc-banner, .smile-panel-frame-container, #mm-subscription-popup[aria-hidden="false"]';
    return Array.from(document.querySelectorAll(selectors)).some(element => {
      if (element === popup || popup.contains(element) || !visible(element)) return false;
      if (element.tagName === 'DETAILS') return visible(element.querySelector(':scope > summary'));
      return true;
    });
  };
  const reset = (form) => {
    const state = locks.get(form);
    if (!state) return;
    window.clearTimeout(state.timer);
    state.buttons.forEach(([button, disabled]) => { button.disabled = disabled; });
    form.removeAttribute('aria-busy');
    const pending = form.querySelector('[data-mm-newsletter-pending]');
    if (pending) pending.hidden = true;
    locks.delete(form);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.mm-newsletter-form')) return;
    if (locks.has(form)) {
      event.preventDefault();
      return;
    }
    if (!form.checkValidity()) return;
    queueMicrotask(() => {
      if (event.defaultPrevented || !form.isConnected) return;
      const buttons = Array.from(form.querySelectorAll('[data-mm-newsletter-submit]')).map(button => [button, button.disabled]);
      buttons.forEach(([button]) => { button.disabled = true; });
      form.setAttribute('aria-busy', 'true');
      const pending = form.querySelector('[data-mm-newsletter-pending]');
      if (pending) pending.hidden = false;
      locks.set(form, { buttons, timer: window.setTimeout(() => reset(form), 10000) });
    });
  });

  const open = (trigger) => {
    const popup = dialog();
    if (!popup || typeof popup.showModal !== 'function') return false;
    if (popup.open) return true;
    if (otherInterfaceOpen(popup)) return false;
    try {
      popup.showModal();
    } catch (_) {
      return false;
    }
    opener = trigger || document.activeElement;
    overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.classList.add('mm-newsletter-open');
    const target = popup.querySelector('[data-mm-newsletter-result]') || popup.querySelector('input[type="email"]');
    if (target) target.focus({ preventScroll: true });
    return true;
  };

  const bindDialog = () => {
    const popup = dialog();
    if (!popup || popup.dataset.mmNewsletterBound === 'true') return;
    popup.dataset.mmNewsletterBound = 'true';
    popup.addEventListener('keydown', (event) => {
      if (!popup.open || event.key !== 'Tab') return;
      const candidates = popup.querySelectorAll('a[href], area[href], button, input, select, textarea, summary, [tabindex], [contenteditable="true"]');
      const focusable = Array.from(candidates).filter(element => element.tabIndex >= 0 && !element.matches(':disabled') && rendered(element));
      if (!focusable.length) {
        event.preventDefault();
        const fallback = popup.querySelector('[data-mm-newsletter-close]') || popup;
        if (fallback === popup) popup.setAttribute('tabindex', '-1');
        fallback.focus();
        return;
      }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;
      if (!focusable.includes(active) || (event.shiftKey && active === first) || (!event.shiftKey && active === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      }
    });
    popup.addEventListener('close', () => {
      document.body.classList.remove('mm-newsletter-open');
      if (overflow !== null) document.body.style.overflow = overflow;
      overflow = null;
      if (opener && opener.isConnected && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
      opener = null;
    });
    popup.addEventListener('click', (event) => {
      if (event.target !== popup) return;
      const bounds = popup.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) popup.close();
    });
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const close = event.target.closest('[data-mm-newsletter-close]');
    if (close) {
      const popup = close.closest('[data-mm-newsletter-dialog]');
      if (popup && popup.open) popup.close();
      return;
    }
    const trigger = event.target.closest('[data-mm-newsletter-open]');
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    bindDialog();
    if (open(trigger)) event.preventDefault();
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.mm-newsletter-form').forEach(reset);
  });
  document.addEventListener('shopify:section:load', bindDialog);
  bindDialog();
  const resultForm = document.getElementById(window.location.hash.slice(1));
  if (resultForm && resultForm.matches('.mm-newsletter-form')) {
    const result = resultForm.querySelector('[data-mm-newsletter-result]');
    if (result) {
      const popup = dialog();
      if (popup && popup.contains(resultForm)) open(null);
      result.focus();
    }
  }
})();
